import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Syncfusion Rich Text Editor CSS imports - Bootstrap theme
import '@syncfusion/ej2-base/styles/bootstrap.css';
import '@syncfusion/ej2-buttons/styles/bootstrap.css';
import '@syncfusion/ej2-inputs/styles/bootstrap.css';
import '@syncfusion/ej2-popups/styles/bootstrap.css';
import '@syncfusion/ej2-lists/styles/bootstrap.css';
import '@syncfusion/ej2-navigations/styles/bootstrap.css';
import '@syncfusion/ej2-dropdowns/styles/bootstrap.css';
import '@syncfusion/ej2-splitbuttons/styles/bootstrap.css';
import '@syncfusion/ej2-filemanager/styles/bootstrap.css';
import '@syncfusion/ej2-react-richtexteditor/styles/bootstrap.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { initReactI18next } from 'react-i18next';
import { LanguageProvider } from './contexts/LanguageContext';

import en from './translations/home/locales/en.json';
import es from './translations/home/locales/es.json';
import fr from './translations/home/locales/fr.json';
import it from './translations/home/locales/it.json';
import de from './translations/home/locales/de.json';
import pt from './translations/home/locales/pt.json';
import ja from './translations/home/locales/ja.json';
import nl from './translations/home/locales/nl.json';
import ko from './translations/home/locales/ko.json';
import pl from './translations/home/locales/pl.json';
import ar from './translations/home/locales/ar.json';
import tr from './translations/home/locales/tr.json';
import zh from './translations/home/locales/zh.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    it: { translation: it },
    fr: { translation: fr },
    de: { translation: de },
    pt: { translation: pt },
    ja: { translation: ja },
    nl: { translation: nl },
    ko: { translation: ko },
    pl: { translation: pl },
    ar: { translation: ar },
    tr: { translation: tr },
    zh: { translation: zh }
  },
  lng: localStorage.getItem('lang') || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }
});
const root = ReactDOM.createRoot(document.getElementById('root'));
window.getPublicUrl = (path) => `${process.env.PUBLIC_URL}/${path}`;
root.render(
  // <React.StrictMode>
  <>
    <I18nextProvider i18n={i18n}>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </I18nextProvider>
  </>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
